<style lang="scss" src="./sidebar.scss"></style>
<template>
  <div class="sideBar">
    <el-scrollbar>
      <el-menu
        :default-active="activeMenu"
        :unique-opened="false"
        :collapse-transition="false"
        class="el-menu-vertical-demo"
        background-color="#fff"
        text-color="#222222"
        active-text-color="#1479FF"
        mode="vertical">
        <sidebar-item
          v-for="item in permission_routes"
          :key="item.path"
          :item='item'
          :basePath="item.path">
        </sidebar-item>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './item'
export default {
  components: { SidebarItem },
  computed: {
    ...mapGetters([
      'permission_routes'
    ]),
    activeMenu () {
      const route = this.$route
      const { name, path } = route
      // if set path, the sidebar will highlight the path you set
      if (name) {
        return name
      }
      return path
    },
    routes () {
      return global.antRouter
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?1d4016d4